import React from 'react'
import "./SubStyle.css"

const CQC_Registration = () => {
  return (
     <section className="SubServices">
     <h1 className="SubServices-title">CQC Registration</h1>
      <p className="SubServices-pera">Starting a care service can be a complex process, but our CQC Registration support makes it straightforward. We assist with applications, policies, procedures, statement of purpose, and regulatory requirements, ensuring your service is fully prepared to meet CQC standards from day one.</p>
         <div className="btn-container">
        <button className="SubServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default CQC_Registration
